import React from "react";
import { observer } from "mobx-react";
import { PageLayout } from "../../../../common/layout";
import { useRootStore } from "../../../../store/contexts";
import { TenantPlanView } from "./TenantPlanView";
import { TenantPlanViewStore } from "../../store/TenantPlanViewStore";
import { useStore } from "../../../../hooks";

export const TenantPlanViewPage = observer(() => {
  const rootStore = useRootStore();
  const { router } = rootStore;

  const id = router.params?.id as string;
  const path = `/tenantPlan/view/${id}`;

  const store = useStore(
    path,
    () => {
      const s = new TenantPlanViewStore(rootStore);
      return s;
    },
    { id }
  );

  return (
    <div>
      <PageLayout
        navigationElements={{
          links: [],
          onNavigatedTo: (id) => {
            store.setCardState(id, true);
          },
        }}
      >
        <TenantPlanView tenantPlanViewStore={store} />
      </PageLayout>
    </div>
  );
});
